;(function() {
  'use strict'

  config.$inject = ["$stateProvider"];
  var dependencies = []

  angular.module('app.survey', dependencies).config(config)

  /* @ngInject */
  function config($stateProvider) {
    $stateProvider.state('app.survey', {
      url:
        '/survey/:id?' +
        [
          'readOnly',
          'channelId',
          'linkId',
          'token',
          'translationId',
          'template',
          'product',
          'place',
          'embedded',
          'tags',
        ].join('&'),
      templateUrl: 'survey.html',
      controller: 'Survey',
      params: {
        data: null,
      },
      reloadOnSearch: false,
      title: 'Survey',
    })
  }
})()
